import Vue from 'vue'

const state = Vue.observable({
  visitedTabs: [],
  activeTab: '/welcome'
})

const tabs = {
  get visitedTabs() {
    return state.visitedTabs
  },
  
  get activeTab() {
    return state.activeTab
  },
  
  init() {
    const savedTabs = sessionStorage.getItem('visitedTabs')
    const savedActiveTab = sessionStorage.getItem('activeTab')
    
    if (savedTabs) {
      try {
        state.visitedTabs = JSON.parse(savedTabs)
      } catch (e) {
        state.visitedTabs = []
      }
    }
    
    if (savedActiveTab) {
      state.activeTab = savedActiveTab
    }
  },
  
  saveState() {
    sessionStorage.setItem('visitedTabs', JSON.stringify(state.visitedTabs))
    sessionStorage.setItem('activeTab', state.activeTab)
  },
  
  addTab(route) {
    if (!route.path || route.path === '/login' || route.path === '/home') {
      return
    }
    
    const exists = state.visitedTabs.some(tab => tab.path === route.path)
    
    if (!exists) {
      state.visitedTabs.push({
        path: route.path,
        name: route.name || route.meta?.title || route.path,
        title: route.meta?.title || route.name || route.path,
        query: route.query || {},
        params: route.params || {}
      })
      this.saveState()
    }
    
    state.activeTab = route.path
    this.saveState()
  },
  
  closeTab(path, router) {
    const index = state.visitedTabs.findIndex(tab => tab.path === path)
    
    if (index === -1) return
    
    state.visitedTabs.splice(index, 1)
    this.saveState()
    
    if (state.activeTab === path) {
      if (state.visitedTabs.length > 0) {
        const nextTab = state.visitedTabs[index] || state.visitedTabs[index - 1]
        if (nextTab) {
          state.activeTab = nextTab.path
          this.saveState()
          if (router) {
            router.push(nextTab.path)
          }
        }
      } else {
        state.activeTab = '/welcome'
        this.saveState()
        if (router) {
          router.push('/welcome')
        }
      }
    }
  },
  
  closeOtherTabs(path) {
    state.visitedTabs = state.visitedTabs.filter(tab => tab.path === path)
    state.activeTab = path
    this.saveState()
  },
  
  closeAllTabs(router) {
    state.visitedTabs = []
    state.activeTab = '/welcome'
    this.saveState()
    if (router) {
      router.push('/welcome')
    }
  },
  
  closeRightTabs(path) {
    const index = state.visitedTabs.findIndex(tab => tab.path === path)
    if (index !== -1) {
      state.visitedTabs = state.visitedTabs.slice(0, index + 1)
      this.saveState()
    }
  },
  
  setActiveTab(path) {
    state.activeTab = path
    this.saveState()
  },
  
  updateTabTitle(path, title) {
    const tab = state.visitedTabs.find(t => t.path === path)
    if (tab) {
      tab.title = title
      tab.name = title
      this.saveState()
    }
  }
}

tabs.init()

export default tabs
